import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'reducers'
import { openModal } from 'reducers/messageReducer'
import { setSearchCondition } from 'reducers/advancedSearchReducer'
import { magiContants as contants } from 'utils/contants'
import { FormControl } from '..'
import { getMcaxs611Init, setSchoolDetailsDepartmentFlag } from 'reducers/advancedSearchModalReducer'
import {
  initRequest,
  UndergraduateDepartmentDetailInfo,
} from '../Config/schoolDepartmentDetailsConfig'
import { Option, SchoolModalState } from '../Config/searchConditionConfig'
import { innerSortFunc } from 'componentsHsc/AdvancedSearchJobChange/Config/searchConditionConfig'

const optionSet = [
  { departmentName: 'てすと', departmentId: 'comprehensiveDeviationValue1' },
]

const useStyles = makeStyles(theme => ({
  actions: {
    justifyContent: 'center',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  modal: {
    '& .MuiDialog-paper': {
      minWidth: '600px',
    },
  },
  dialogTitle: {
    color: (theme.palette as any).white,
    backgroundColor: '#133e80',
    '&:hover': {
      backgroundColor: '#133e80',
    },
  },
  title: {
    color: (theme.palette as any).white,
    fontWeight: 900,
    fontSize: 18,
    cursor:'auto',
  },
  link: {
    paddingTop: 15,
    paddingLeft: 15,
    paddingBottom: 0,
  },
  checkbox: {
    //display: 'grid',
    gridTemplateColumns: 'repeat(3, [col-start] max-content [col-end])',
    padding: 15,
  },

  button: {
    marginLeft: theme.spacing(2.5),
    color: (theme.palette as any).white,
    backgroundColor: '#3380cc',
    '&:hover': {
      backgroundColor: '#23598e',
    },
    width: '30%',
  },
  cancel: {
    marginRight: theme.spacing(2.5),
    color: (theme.palette as any).black,
    backgroundColor: '#e0e0e0',
    '&:hover': {
      backgroundColor: '#c1d1eb',
    },
    width: 130,
  },
  confirmButton: {
    marginLeft: theme.spacing(2.5),
    color: (theme.palette as any).white,
    backgroundColor: '#3380cc',
    '&:hover': {
      backgroundColor: '#23598e',
    },
    width: 130,
  },
  formContainer: {
    paddingTop: 0,
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  content: {
    float: 'left',
    '& div': {
      display: 'inline-block',
      margin: '0px 19px 0px 0px',
      cursor: 'pointer',
    },
    '& div input': {
      marginRight: '5px',
      cursor: 'pointer',
    }
  },
}))

interface Props {
  open: boolean
  onClose: () => void
  title: string
  form: FormControl
  modalState: SchoolModalState
}

const SchoolDepartmentDetails = ({ open, onClose, title, form, modalState }: Props) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const searchConditionValues = useSelector(
    (state: RootState) => state.advancedSearch.searchCondition
  )
  const { undergraduateDepartmentDetailsList } = useSelector(
    (state: RootState) => state.advancedSearchModal.schoolDepartmentDetailsInfo
  )

  useEffect(() => {
    if(open){
      setSelectSchoolDepartmentDetails(form.values.undergraduateDepartmentObj || [])
    }
  }, [open])

  const [openCancelDialog, setOpenCancelDialog] = useState(false)
  const [openSchoolDetailDialog, setOpenSchoolDetailDialog] = useState(false)

  const [
    selectSchoolDepartmentDetails,
    setSelectSchoolDepartmentDetails,
  ] = useState(modalState.schoolDepartmentDetailsSelected || [])

  useEffect(() => {
    setSelectSchoolDepartmentDetails(
      form.values.undergraduateDepartmentObj || []
    )
  }, [form.values.undergraduateDepartmentObj])

  // キャンセル確認ダイアログ表示
  const handleClickDialog = () => {
    setOpenCancelDialog(true)
  }

  // 学校詳細遷移確認ダイアログ表示
  const handleSchoolDetailDialog = () => {
    if (selectSchoolDepartmentDetails.length > 0) {
      setOpenSchoolDetailDialog(true)
    } else {
      modalState.schoolDetails = true
      dispatch(setSchoolDetailsDepartmentFlag(true))
      onClose()
    }
  }

  const handleCancel = () => {
    setOpenCancelDialog(false)
    setOpenSchoolDetailDialog(false)
  }

  const handleCancelOk = () => {
    setOpenCancelDialog(false)
    onClose()
  }

  const handleClick = (modalName: string, open = true) => () => {
    if ( modalName === 'schoolDetails' ) {
      modalState.schoolDetails = true
      dispatch(setSchoolDetailsDepartmentFlag(true))
      if(!form.values.undergraduateDepartmentObj){
        setSelectSchoolDepartmentDetails([])
      }
      onClose()
    }
    setOpenSchoolDetailDialog(false)
  }

  // チェックボックス処理
  const handleSelect = (detail: Option) => (e: any) => {
    const selectSchoolDepartmentDetailsOption = selectSchoolDepartmentDetails.filter(i => i.subjcetInfomationDagagaMasterId === detail.value)
    if (selectSchoolDepartmentDetailsOption.length > 0) {
      setSelectSchoolDepartmentDetails(
        selectSchoolDepartmentDetails.filter(i => i.subjcetInfomationDagagaMasterId !== detail.value)
      )
    } else {
      undergraduateDepartmentDetailsList.filter(i => i.subjectInformationDagagaMasterId === detail.value).forEach(i => {
        setSelectSchoolDepartmentDetails([
          ...selectSchoolDepartmentDetails,
          {
            schoolTypeCode: i.schoolTypeCode,
            schoolTypeName: i.schoolTypeName,
            collegeCode: i.collegeCode,
            collegeName: i.collegeName,
            facultyCode: i.facultyCode,
            facultyName: i.facultyName,
            subjectCode: i.subjectCode,
            subjectName: i.subjectName,
            subjcetInfomationDagagaMasterId: i.subjectInformationDagagaMasterId,
          }
        ])
      })
    }
  }

  // OKボタン押下時
  const handleOk = () => {
    const newSarchConditionValues: any = Object.assign(
      {},
      searchConditionValues
    )
    const newSchoolGroupValues: any[] = []
    const newUndergraduateDepartmentObj: any[] = []

    if (selectSchoolDepartmentDetails.length > 0) {
      selectSchoolDepartmentDetails.map(i => 
        undergraduateDepartmentDetailsList
          .filter(j => i.subjcetInfomationDagagaMasterId === j.subjectInformationDagagaMasterId)
          .map(j => {
            newSchoolGroupValues.push(j)
            newUndergraduateDepartmentObj.push(i)
          }))
    }

    const orderObjArray = undergraduateDepartmentDetailsList.map(i=>({
      schoolTypeCode: i.schoolTypeCode,
      collegeCode: i.collegeCode,
      facultyCode: i.facultyCode,
      subjectCode: i.subjectCode
    }))
    const sortedUndergraduateDepartmentObj = [...newUndergraduateDepartmentObj].sort((a, b) => {
      return innerSortFunc(
        {
          schoolTypeCode: a.schoolTypeCode,
          collegeCode: a.collegeCode,
          facultyCode: a.facultyCode,
          subjectCode: a.subjectCode
        },
        {
          schoolTypeCode: b.schoolTypeCode,
          collegeCode: b.collegeCode,
          facultyCode: b.facultyCode,
          subjectCode: b.subjectCode
        },
        orderObjArray,
      )
    })

    newSarchConditionValues.SchoolDepartmentDetails = newSchoolGroupValues
    dispatch(setSearchCondition(newSarchConditionValues))
    onClose()
    setOpenSchoolDetailDialog(false)

    form.setFieldValue(
      'undergraduateDepartmentObj',
      sortedUndergraduateDepartmentObj
    )
    form.setFieldValue('schoolDetailsObj', modalState.schoolDetailsSelected)
    form.setFieldValue('schoolGroupObj', modalState.schoolGroupSelected)
    modalState.schoolDepartmentDetailsSelected = sortedUndergraduateDepartmentObj
  }

  return (
    <div>
      <Dialog fullWidth open={open} className={classes.modal + ' mainDialog'} maxWidth='lg'>
        <DialogTitle className={classes.dialogTitle}>
          <label className={classes.title}>{title}</label>
        </DialogTitle>
        <DialogContent className={classes.checkbox}>
          {undergraduateDepartmentDetailsList
            ? undergraduateDepartmentDetailsList
                .map(i => ({
                  value: i.subjectInformationDagagaMasterId,
                  label: i.collegeName + " " + i.facultyName + " " + i.subjectName,
                }))
                .map(detail => (
                  <div className={classes.content}>
                    <div onClick={handleSelect(detail)} >
                      <input type="checkbox" checked={selectSchoolDepartmentDetails.some(
                        i => i.subjcetInfomationDagagaMasterId === detail.value
                      )} />{detail.label}
                    </div>
                  </div>
                ))
            : null}
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Button
            onClick={handleSchoolDetailDialog}
            color='primary'
            variant='contained'
            className={classes.button}>
            学校詳細を指定する
          </Button>
        </DialogActions>
        <DialogActions className={classes.actions}>
          <Button
            onClick={handleClickDialog}
            color='primary'
            variant='contained'
            className={classes.cancel}>
            キャンセルする
          </Button>
          <Button
            onClick={handleOk}
            color='primary'
            variant='contained'
            className={classes.confirmButton}>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openCancelDialog} onClose={handleCancel}>
        <DialogTitle>{contants.MESSAGECODE_MCAXS611_003}</DialogTitle>
        <DialogActions>
          <Button onClick={handleCancel}>キャンセル</Button>
          <Button onClick={handleCancelOk} color='primary'>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openSchoolDetailDialog} onClose={handleCancel}>
        <DialogTitle>{contants.MESSAGECODE_MCAXS611_002}</DialogTitle>
        <DialogActions>
          <Button onClick={handleCancel}>キャンセル</Button>
          <Button onClick={handleClick('schoolDetails')} color='primary'>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export { SchoolDepartmentDetails }
